"use strict";

// MV SWIPER（zoom-out & fade）
var mvSwiper = new Swiper(".mv__swiper", {
  allowTouchMove: false,
  simulateTouch: false,
  effect: "fade",
  fadeEffect: {
    crossFade: true,
  },
  speed: 2000,
  autoplay: {
    delay: 3000,
    disableOnInteraction: false,
  },
  loop: true,
  on: {
    slideChangeTransitionStart: function slideChangeTransitionStart() {
      var activeSlide = this.slides[this.activeIndex];
      activeSlide.classList.add("is-zoom");
    },
    slideChangeTransitionEnd: function slideChangeTransitionEnd() {
      this.slides.forEach(function (slide) {
        if (!slide.classList.contains("swiper-slide-active")) {
          slide.classList.remove("is-zoom");
        }
      });
    },
    init: function init() {
      this.slides[this.activeIndex].classList.add("is-zoom");
    },
  },
});

// PICKUP SCROLL
window.addEventListener("scroll", function () {
  var pickup = document.querySelector(".pickup");
  if (pickup.getBoundingClientRect().top <= 0) {
    document.body.classList.add("is-pickup");
  } else {
    document.body.classList.remove("is-pickup");
  }
});

// Pickup
var pickup = new Swiper(".pickup__swiper", {
  allowTouchMove: false,
  simulateTouch: false,
  slidesPerView: "auto",
  centeredSlides: true,
  loop: true,
  speed: 500,
  spaceBetween: 5,
  autoplay: {
    delay: 5000,
    disableOnInteraction: false,
  },
  pagination: {
    el: ".swiper__navi__pagination",
    clickable: true,
  },
  navigation: {
    prevEl: ".swiper__navi__prev",
    nextEl: ".swiper__navi__next",
  },
  breakpoints: {
    // 768px未満（SP）のみタッチ有効
    0: {
      allowTouchMove: true,
      simulateTouch: true,
    },
    768: {
      allowTouchMove: false,
      simulateTouch: false,
    },
  },
});

// New Arrivals
var newArrivals = new Swiper(".new-arrivals__swiper", {
  allowTouchMove: false,
  simulateTouch: false,
  slidesPerView: "auto",
  loop: true,
  loopedSlides: 6,
  speed: 500,
  centeredSlides: false,
  pagination: {
    el: ".swiper__navi__pagination",
    clickable: true,
  },
  navigation: {
    prevEl: ".swiper__navi__prev",
    nextEl: ".swiper__navi__next",
  },
  breakpoints: {
    0: {
      centeredSlides: true,
      allowTouchMove: true,
      simulateTouch: true,
    },
    768: {
      centeredSlides: false,
      allowTouchMove: false,
      simulateTouch: false,
    },
  },
});

// Collaboration
var collab = new Swiper(".collab__swiper", {
  allowTouchMove: false,
  simulateTouch: false,
  slidesPerView: "auto",
  //loop: true,
  speed: 500,
  navigation: {
    prevEl: ".collab__nav__prev",
    nextEl: ".collab__nav__next",
  },
  pagination: {
    el: ".collab__nav__status",
    type: "progressbar",
  },
  breakpoints: {
    // 768px未満（SP）のみタッチ有効
    0: {
      allowTouchMove: true,
      simulateTouch: true,
    },
    768: {
      allowTouchMove: false,
      simulateTouch: false,
    },
  },
});

// Feature
var feature = new Swiper(".feature__swiper", {
  allowTouchMove: false,
  simulateTouch: false,
  slidesPerView: "auto",
  loop: true,
  speed: 500,
  autoplay: {
    delay: 4000,
    disableOnInteraction: false,
  },
  navigation: {
    prevEl: ".feature__nav__prev",
    nextEl: ".feature__nav__next",
  },
  breakpoints: {
    // 768px未満（SP）のみタッチ有効
    0: {
      allowTouchMove: true,
      simulateTouch: true,
    },
    768: {
      allowTouchMove: false,
      simulateTouch: false,
    },
  },
});

//Lineup
jQuery(function ($) {
  $(".lineup__item__head").on("click", function () {
    var $item = $(this).closest(".lineup__item");
    $item.toggleClass("is-active");
    $item.find(".lineup__item__inner").slideToggle(300);
  });
});

const lineupHead = document.querySelector('.lineup__head');
const lineupSection = document.querySelector('.lineup');

if (lineupHead && lineupSection) {
  let threshold;

  const computeThreshold = () => {
    let top = 0;
    let el = lineupSection;
    while (el) {
      top += el.offsetTop;
      el = el.offsetParent;
    }
    threshold = top;
  };

  const checkLineupHead = () => {
    if (window.scrollY >= threshold) {
      lineupHead.classList.add('is-center');
    } else {
      lineupHead.classList.remove('is-center');
    }
  };

  computeThreshold();
  window.addEventListener('scroll', checkLineupHead, { passive: true });
  window.addEventListener('resize', () => { computeThreshold(); checkLineupHead(); });
  checkLineupHead();
}

//FIND
var find = new Swiper(".find__swiper", {
  loop: true,
  slidesPerView: "auto",
  speed: 30000,
  allowTouchMove: false,
  simulateTouch: false,
  autoplay: {
    delay: 0,
    disableOnInteraction: false,
  },
});
var fadeUpObserver = new IntersectionObserver(
  function (entries) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) {
        entry.target.classList.add("is-show");
        fadeUpObserver.unobserve(entry.target);
      }
    });
  },
  {
    threshold: 0.1,
  },
);
document.querySelectorAll(".view").forEach(function (el) {
  fadeUpObserver.observe(el);
});
